module.exports = __webpack_public_path__ + "static/media/imgHome_CardUs_PC.29424857.png";